
export const actionTypes = {
	ALERT_SUCCESS: 'alertlj/ALERT_SUCCESS',
	ALERT_ERROR: 'alertlj/ALERT_ERROR',
	CLEAR_ALERT: 'alertlj/CLEAR_ALERT'
}


export const showAlertError = (message) => {
	return(dispatch, getstore) => {
		dispatch(alertError(message))
		setTimeout(() => {
			dispatch(clearAlert())
		}, 4000)
	}
}

export const showAlertSuccess = (message) => {
	return(dispatch, getstore) => {
		dispatch(alertSuccess(message))
		setTimeout(() => {
			dispatch(clearAlert())
		}, 4000)
	}
}


export const alertSuccess = (message) => {
  return {
    type: actionTypes.ALERT_SUCCESS,
    data: { message: message }
  }
}

export const alertError = (message) => {
  return {
    type: actionTypes.ALERT_ERROR,
    data: { message: message }
  }
}

export const clearAlert = () => {
  return {
    type: actionTypes.CLEAR_ALERT
  }
}



// WEBPACK FOOTER //
// ./src/actions/alertlj.js